module.exports = __webpack_public_path__ + "static/media/spin-mobile-logo.0165e794.png";